import { useEffect, useState } from 'react';

import { useDebounceEffect } from 'ahooks';

import { formatInputValue, isCurrencyField, parseNumber } from './renewalVsTurnover';

import type { RenewalVsTurnoverFieldName, RenewalVsTurnoverValues } from './renewalVsTurnover';

const PARAM_PREFIX = 'rvt_';

const readValuesFromUrl = (params: URLSearchParams, defaults: RenewalVsTurnoverValues): RenewalVsTurnoverValues => {
  const values = { ...defaults };
  (Object.keys(defaults) as Array<RenewalVsTurnoverFieldName>).forEach((field) => {
    const param = params.get(`${PARAM_PREFIX}${field}`);
    if (param !== null && parseNumber(param) !== undefined) {
      values[field] = formatInputValue(param, isCurrencyField(field));
    }
  });
  return values;
};

const writeValuesToUrl = (values: RenewalVsTurnoverValues, defaults: RenewalVsTurnoverValues) => {
  const url = new URL(window.location.href);
  (Object.keys(defaults) as Array<RenewalVsTurnoverFieldName>).forEach((field) => {
    const parsed = parseNumber(values[field]);
    if (parsed === undefined || parsed === parseNumber(defaults[field])) {
      url.searchParams.delete(`${PARAM_PREFIX}${field}`);
    } else {
      url.searchParams.set(`${PARAM_PREFIX}${field}`, String(parsed));
    }
  });
  if (url.href !== window.location.href) {
    window.history.replaceState(window.history.state, '', url);
  }
};

const useRenewalVsTurnoverUrlState = (defaults: RenewalVsTurnoverValues) => {
  const [values, setValues] = useState(defaults);
  const [isUrlRead, setIsUrlRead] = useState(false);

  useEffect(() => {
    setValues(readValuesFromUrl(new URLSearchParams(window.location.search), defaults));
    setIsUrlRead(true);
  }, [defaults]);

  useDebounceEffect(
    () => {
      if (isUrlRead) {
        writeValuesToUrl(values, defaults);
      }
    },
    [values, isUrlRead, defaults],
    { wait: 300 },
  );

  return { values, setValues };
};

export default useRenewalVsTurnoverUrlState;
